import { Link } from "react-router-dom";

export function Logo({ className = "", dark = false, testId = "tenet-logo" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid={testId}>
      <span className={`grid place-items-center h-10 w-10 rounded-full overflow-hidden ${dark ? "ring-1 ring-amber-500/30" : "ring-1 ring-[#1F3D2E]/15"}`}>
        <img src="/tenet-logo.jpg" alt="TENET lighthouse" className="h-full w-full object-cover" />
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-cinzel text-lg font-semibold tracking-[0.18em] ${dark ? "text-stone-50" : "text-[#1F3D2E]"}`}>
          TENET
        </span>
        <span
          className={`font-cinzel mt-1 tracking-[0.32em] ${dark ? "text-amber-300/80" : "text-[#8B6F3D]"}`}
          style={{ fontSize: "0.5rem" }}
        >
          TRANSFORMATION
        </span>
      </span>
    </span>
  );
}

export function SacredFlameMark({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="sacred-flame-logo">
      <span className="grid place-items-center h-10 w-10 rounded-full bg-gradient-to-b from-amber-500/30 to-rose-900/20 border border-amber-500/40">
        <i className="fa-solid fa-fire text-amber-400" />
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-serif-display text-2xl text-amber-100">Sacred Flame</span>
        <span className="text-amber-300/70 font-mono text-[0.55rem] tracking-[0.28em] uppercase mt-1">
          Methodology
        </span>
      </span>
    </span>
  );
}

export function LinkLogo() {
  return (
    <Link to="/" aria-label="TENET home" data-testid="nav-logo-link">
      <Logo />
    </Link>
  );
}
